import { render, staticRenderFns } from "./S3Image.vue?vue&type=template&id=814fed8a&"
import script from "./S3Image.vue?vue&type=script&lang=ts&"
export * from "./S3Image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports